import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import { InfoBoxes } from '@/components/boxes';
import React from 'react';
import IconEducation from '@/assets/icons/heroIcons/Education.svg';
import IconHeart from '@/assets/icons/heroIcons/Heart.svg';
import IconTarget from '@/assets/icons/heroIcons/Target.svg';
import { Link } from '@/components/links';
import { useRouter } from 'next/router';
import { FILES } from '@/constants/files';
export function Facts() {
  const $ = _c(46);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["aboutUs"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    locale
  } = useRouter();
  let t1;
  if ($[1] !== t) {
    t1 = t("facts.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-10 px-0 lg:mb-16" anchorKey="facts.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("facts.items.1.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== locale) {
    t4 = FILES(locale);
    $[7] = locale;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4.ethicalCodex) {
    t5 = <Link analyticsParam="ethicalCodex" testId="ethicalCodex" to={t4.ethicalCodex} target="_blank" />;
    $[9] = t4.ethicalCodex;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== locale) {
    t6 = FILES(locale);
    $[11] = locale;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6.criminalActivity) {
    t7 = <Link analyticsParam="criminalActivity" testId="criminalActivity" to={t6.criminalActivity} target="_blank" />;
    $[13] = t6.criminalActivity;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t || $[16] !== t5 || $[17] !== t7) {
    t8 = <Trans t={t} i18nKey="facts.items.1.text">{t5}{t7}</Trans>;
    $[15] = t;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <IconTarget />;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t3 || $[21] !== t8) {
    t10 = {
      title: t3,
      paragraph: t8,
      icon: t9
    };
    $[20] = t3;
    $[21] = t8;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t("facts.items.2.title");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t("facts.items.2.text");
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <IconHeart />;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t11 || $[29] !== t12) {
    t14 = {
      title: t11,
      paragraph: t12,
      icon: t13
    };
    $[28] = t11;
    $[29] = t12;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t) {
    t15 = t("facts.items.3.title");
    $[31] = t;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t) {
    t16 = t("facts.items.3.text");
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <IconEducation />;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t15 || $[37] !== t16) {
    t18 = {
      title: t15,
      paragraph: t16,
      icon: t17
    };
    $[36] = t15;
    $[37] = t16;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t10 || $[40] !== t14 || $[41] !== t18) {
    t19 = <InfoBoxes items={[t10, t14, t18]} variant="basic" />;
    $[39] = t10;
    $[40] = t14;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t19 || $[44] !== t2) {
    t20 = <div className="px-4">{t2}{t19}</div>;
    $[43] = t19;
    $[44] = t2;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  return t20;
}